/*
  Add Custom JS to be layered on top of ciritical theme js
*/

const CartMessage = {
  tag: '',
  specificTitle: '',
  maxItemsToShow: 0,

  init: () => {
    const messageElement = document.getElementById('cart-message');

    if (!messageElement) return;

    CartMessage.tag = messageElement.dataset.tag;
    CartMessage.specificTitle = messageElement.dataset.title;
    CartMessage.maxItemsToShow = messageElement.dataset.after;

    console.log('CartMessage', CartMessage);
  },

  checkCartItems: () => {
    const cartItems = Neptune.liquid.items.Cart.data.items;
    let shouldShowMessage = false;

    if (!shouldShowMessage && CartMessage.tag != undefined) {
      shouldShowMessage = cartItems.some(item => item.properties._message === 'cart');
    }  

    if (!shouldShowMessage && CartMessage.specificTitle !== undefined) {
      const normalizedSpecificTitle = CartMessage.specificTitle.trim().toLowerCase();
      shouldShowMessage = cartItems.some(item => item.product_title.trim().toLowerCase().includes(normalizedSpecificTitle));
    }

    if (CartMessage.tag == undefined && CartMessage.specificTitle == undefined) {
      shouldShowMessage = true;
    }

    if (CartMessage.maxItemsToShow > 0 && cartItems.length > CartMessage.maxItemsToShow) {
      shouldShowMessage = false;
    }

    CartMessage.showOrHideMessage(shouldShowMessage);
  },

  showOrHideMessage: (show) => {
    const messageElement = document.getElementById('cart-message');

    if (show) {
      messageElement.classList.remove('hidden');
      messageElement.classList.add('block');
    } else {
      messageElement.classList.add('hidden');
      messageElement.classList.remove('block');
    }
  },

  run: () => {
    CartMessage.init();
    CartMessage.checkCartItems();
  }
}

window.CartMessage = CartMessage;

document.addEventListener('DOMContentLoaded', function() {
  CartMessage.run();
});

document.addEventListener('cart:itemAdded', function() {
  setTimeout(() => {
    CartMessage.run();
  }, 500);
});
